import { LitElement, html, svg } from 'lit';

export class IconEdit32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Blyant</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M29.284 2.716a4.742 4.742 0 0 0-6.74.045L3.641 21.665l-2.308 9.002 9.002-2.31L29.238 9.455a4.742 4.742 0 0 0 .046-6.738v0Z"></path></svg>`; }
}
if (!customElements.get('f-icon-edit32', IconEdit32)) {
  customElements.define('f-icon-edit32', IconEdit32);
}